var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento ordine MTM...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.ordine && _vm.ordine != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c("v-flex", { attrs: { xs8: "" } }, [
                                            _c(
                                              "h3",
                                              { staticClass: "headline mb-0" },
                                              [
                                                _vm._v("ORDINE NR: "),
                                                _c("strong", [
                                                  _vm._v(_vm._s(_vm.ordine.id)),
                                                ]),
                                              ]
                                            ),
                                            _c("div", [
                                              _vm.ordine.vecchioNuovo == "O"
                                                ? _c("span", [
                                                    _vm._v(" VECCHIO "),
                                                  ])
                                                : _vm.ordine.vecchioNuovo == "N"
                                                ? _c("span", [
                                                    _vm._v(" NUOVO "),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                            _c("br"),
                                            _c("div", [
                                              _vm._v("NEGOZIO: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.ordine.negozio)
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("ID CLIENTE: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.ordine.idCliente)
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("PRIORITA': "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.ordine.priorita)
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("DATA CONSEGNA: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      _vm.ordine.dataConsegna
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("FLAG ETICHETTA: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine.flagEtichetta
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("DATA ETICHETTA: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine.dataEtichetta
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v("DESCRIZIONE ETICHETTA: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine
                                                      .descrizioneEtichetta
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("br"),
                                            _c("div", [
                                              _vm._v("PAPILLON: "),
                                              _vm.ordine.papillon
                                                ? _c("strong", [_vm._v("SI'")])
                                                : _c("strong", [_vm._v("NO")]),
                                            ]),
                                            _c("div", [
                                              _vm._v("FASCIA SMOKING: "),
                                              _vm.ordine.fasciaSmoking
                                                ? _c("strong", [_vm._v("SI'")])
                                                : _c("strong", [_vm._v("NO")]),
                                            ]),
                                            _vm.ordine.monoPancUnoEMezzo
                                              ? _c("div", [
                                                  _vm._v("TIPO GIACCA: "),
                                                  _vm.ordine
                                                    .monoPancUnoEMezzo == "M"
                                                    ? _c("strong", [
                                                        _vm._v("MONOPETTO"),
                                                      ])
                                                    : _vm.ordine
                                                        .monoPancUnoEMezzo ==
                                                      "P"
                                                    ? _c("strong", [
                                                        _vm._v("PANCIOTTO"),
                                                      ])
                                                    : _vm.ordine
                                                        .monoPancUnoEMezzo ==
                                                      "U"
                                                    ? _c("strong", [
                                                        _vm._v("UNO E MEZZO"),
                                                      ])
                                                    : _vm._e(),
                                                ])
                                              : _vm._e(),
                                            _vm.ordine.noteOrdine
                                              ? _c("br")
                                              : _vm._e(),
                                            _vm.ordine.noteOrdine
                                              ? _c("div", [
                                                  _c("strong", [
                                                    _vm._v("Note: "),
                                                  ]),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ordine.noteOrdine
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.showDatiFornitoreSendReminder
                                              ? _c("div", [
                                                  _c("br"),
                                                  _vm.righeDatiFornitoreToSend
                                                    .length == 1
                                                    ? _c(
                                                        "strong",
                                                        {
                                                          staticStyle: {
                                                            color: "#855b5b",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "É PRESENTE " +
                                                              _vm._s(
                                                                _vm
                                                                  .righeDatiFornitoreToSend
                                                                  .length
                                                              ) +
                                                              " RIGA MTM SU " +
                                                              _vm._s(
                                                                _vm.ordine
                                                                  .righeMtm
                                                                  .length
                                                              ) +
                                                              " DELLA QUALE NON SONO STATI INVIATI I DATI FORNITORE "
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "strong",
                                                        {
                                                          staticStyle: {
                                                            color: "#855b5b",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "SONO PRESENTI " +
                                                              _vm._s(
                                                                _vm
                                                                  .righeDatiFornitoreToSend
                                                                  .length
                                                              ) +
                                                              " RIGHE MTM SU " +
                                                              _vm._s(
                                                                _vm.ordine
                                                                  .righeMtm
                                                                  .length
                                                              ) +
                                                              " DELLE QUALI NON SONO STATI INVIATI I DATI FORNITORE "
                                                          ),
                                                        ]
                                                      ),
                                                ])
                                              : _vm._e(),
                                            _vm.isStampaEtichettaLoading
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-center",
                                                  },
                                                  [
                                                    _c("v-progress-circular", {
                                                      attrs: {
                                                        size: 50,
                                                        color: "primary",
                                                        indeterminate: "",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "10px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "10px",
                                                          "margin-bottom":
                                                            "10px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                              width: "260px",
                                                            },
                                                            attrs: {
                                                              color:
                                                                "secondary",
                                                              disabled:
                                                                !_vm.canPrintEtichette ||
                                                                !_vm.stampaEtichetteRfidDisponibile,
                                                              size: "x-large",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.stampaEtichettePerOrdine(
                                                                  "PRINT_RFID"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Stampa Etichetta RFID"
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  right: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-barcode-scan"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticStyle: {
                                                              "margin-right":
                                                                "10px",
                                                              width: "260px",
                                                            },
                                                            attrs: {
                                                              color:
                                                                "secondary",
                                                              disabled:
                                                                !_vm.canPrintEtichette ||
                                                                !_vm.stampaEtichetteNoRfidDisponibile,
                                                              size: "x-large",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.stampaEtichettePerOrdine(
                                                                  "PRINT_NORFID"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Stampa Etichetta NO-RFID"
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  right: "",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-barcode"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.canResetEPC
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                staticStyle: {
                                                                  width:
                                                                    "130px",
                                                                },
                                                                attrs: {
                                                                  color:
                                                                    "secondary",
                                                                  disabled:
                                                                    !_vm.canPrintEtichette ||
                                                                    !_vm.stampaEtichetteRfidDisponibile,
                                                                  size: "x-large",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.stampaEtichettePerOrdine(
                                                                        "RESET_EPC"
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Reset EPC"
                                                                ),
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      right: "",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-barcode-off"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _c("v-flex", { attrs: { xs4: "" } }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticStyle: {
                                                      float: "right",
                                                      margin: "0 10px 20px 0",
                                                      "item-aligns": "center",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.ordine.stato
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              (_vm.ordine.variazioniTestata || []).length > 0
                                ? _c(
                                    "v-card",
                                    {
                                      staticClass: "mt-4",
                                      attrs: { hover: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showVariazioniTestata =
                                            !_vm.showVariazioniTestata
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "mb-0" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "VARIAZIONI DETTAGLI GENERALI"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "active-expansion":
                                                      _vm.showVariazioniTestata,
                                                  },
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v(" mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (_vm.ordine.variazioniTestata || []).length > 0 &&
                              _vm.showVariazioniTestata
                                ? _c(
                                    "v-list",
                                    [
                                      _vm._l(
                                        _vm.ordine.variazioniTestata,
                                        function (variazione, i) {
                                          return [
                                            _c("ItemListVariazioneOrdineMTM", {
                                              key: variazione.id,
                                              attrs: { variazione: variazione },
                                              on: {
                                                "conferma-variazione":
                                                  _vm.confermaVariazioneTestata,
                                              },
                                            }),
                                            i <
                                            _vm.ordine.variazioniTestata
                                              .length -
                                              1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("RIGHE MTM")]),
                              ]),
                              (_vm.ordine.variazioniArrayItemsRigheMtm || [])
                                .length > 0
                                ? _c(
                                    "v-card",
                                    {
                                      class: {
                                        "mb-4":
                                          !_vm.showVariazioniArrayItemsRigheMtm,
                                      },
                                      attrs: { hover: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showVariazioniArrayItemsRigheMtm =
                                            !_vm.showVariazioniArrayItemsRigheMtm
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "mb-0" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "VARIAZIONI ELEMENTI RIGHE MTM"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "active-expansion":
                                                      _vm.showVariazioniArrayItemsRigheMtm,
                                                  },
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v(" mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (_vm.ordine.variazioniArrayItemsRigheMtm || [])
                                .length > 0 &&
                              _vm.showVariazioniArrayItemsRigheMtm
                                ? _c(
                                    "v-list",
                                    { staticClass: "mb-4" },
                                    [
                                      _vm._l(
                                        _vm.ordine.variazioniArrayItemsRigheMtm,
                                        function (variazione, i) {
                                          return [
                                            _c(
                                              "ItemListVariazioneArrayItemsOrdineMTM",
                                              {
                                                key: variazione.id,
                                                attrs: {
                                                  displayProperty:
                                                    "modello-stagione-colore",
                                                  variazione: variazione,
                                                },
                                                on: {
                                                  "conferma-variazione": (e) =>
                                                    _vm.confermaVariazioneArrayItems(
                                                      e,
                                                      "RigheMTM"
                                                    ),
                                                },
                                              }
                                            ),
                                            i <
                                            _vm.ordine
                                              .variazioniArrayItemsRigheMtm
                                              .length -
                                              1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-list",
                                    { style: { padding: "0" } },
                                    [
                                      _vm._l(
                                        _vm.ordine.righeMtm,
                                        function (riga, k) {
                                          return [
                                            _c("ItemListRigaMTM", {
                                              key: k,
                                              attrs: {
                                                statoOrdine: _vm.ordine.stato,
                                                idRiga: _vm.idRiga,
                                                idLidAssociataCorrente:
                                                  _vm.idLidAssociata,
                                                riga: riga,
                                              },
                                              on: {
                                                "conferma-variazione": (e) =>
                                                  _vm.confermaVariazioneSubArray(
                                                    e,
                                                    "RigheMTM"
                                                  ),
                                                "invia-note-consegna-riga-mtm":
                                                  _vm.inviaNoteConsegnaRigaMtm,
                                                "invia-dati-consegna-riga-mtm":
                                                  _vm.inviaDatiOrdineConsegnaRigaMtm,
                                              },
                                            }),
                                            k < _vm.ordine.righeMtm.length - 1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.ordine.ordiniAssociati.length > 0
                            ? _c(
                                "v-flex",
                                { attrs: { xs10: "", "offset-xs1": "" } },
                                [
                                  _c("v-card-title", [
                                    _c("h2", [_vm._v("ORDINI ASSOCIATI")]),
                                  ]),
                                  _c("OrdiniList", {
                                    attrs: {
                                      "data-test": "lista-ordini",
                                      ordini: _vm.ordine.ordiniAssociati,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("MISURE CLIENTE")]),
                              ]),
                              (
                                _vm.ordine.variazioniArrayItemsMisureCliente ||
                                []
                              ).length > 0
                                ? _c(
                                    "v-card",
                                    {
                                      class: {
                                        "mb-4":
                                          !_vm.showVariazioniArrayItemsMisureCliente,
                                      },
                                      attrs: { hover: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showVariazioniArrayItemsMisureCliente =
                                            !_vm.showVariazioniArrayItemsMisureCliente
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "mb-0" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "VARIAZIONI ELEMENTI MISURE CLIENTE"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "active-expansion":
                                                      _vm.showVariazioniArrayItemsMisureCliente,
                                                  },
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v(" mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (
                                _vm.ordine.variazioniArrayItemsMisureCliente ||
                                []
                              ).length > 0 &&
                              _vm.showVariazioniArrayItemsMisureCliente
                                ? _c(
                                    "v-list",
                                    { staticClass: "mb-4" },
                                    [
                                      _vm._l(
                                        _vm.ordine
                                          .variazioniArrayItemsMisureCliente,
                                        function (variazione, i) {
                                          return [
                                            _c(
                                              "ItemListVariazioneArrayItemsOrdineMTM",
                                              {
                                                key: variazione.id,
                                                attrs: {
                                                  displayProperty:
                                                    "nome misura",
                                                  variazione: variazione,
                                                },
                                                on: {
                                                  "conferma-variazione": (e) =>
                                                    _vm.confermaVariazioneArrayItems(
                                                      e,
                                                      "MisureCliente"
                                                    ),
                                                },
                                              }
                                            ),
                                            i <
                                            _vm.ordine
                                              .variazioniArrayItemsMisureCliente
                                              .length -
                                              1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-list",
                                    { style: { padding: "0" } },
                                    [
                                      _vm._l(
                                        _vm.ordine.misureCliente,
                                        function (m, k) {
                                          return [
                                            _c("ItemListMisuraCliente", {
                                              key: k,
                                              attrs: { misura: m },
                                              on: {
                                                "conferma-variazione": (e) =>
                                                  _vm.confermaVariazioneSubArray(
                                                    e,
                                                    "MisureCliente"
                                                  ),
                                              },
                                            }),
                                            k <
                                            _vm.ordine.misureCliente.length - 1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c("v-card-title", [
                                _c("h2", [_vm._v("VARIAZIONI MISURE")]),
                              ]),
                              (_vm.ordine.variazioniArrayItemsMisureMtm || [])
                                .length > 0
                                ? _c(
                                    "v-card",
                                    {
                                      class: {
                                        "mb-4":
                                          !_vm.showVariazioniArrayItemsMisureMtm,
                                      },
                                      attrs: { hover: "" },
                                      on: {
                                        click: function ($event) {
                                          _vm.showVariazioniArrayItemsMisureMtm =
                                            !_vm.showVariazioniArrayItemsMisureMtm
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-card-text",
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "mb-0" },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "VARIAZIONI ELEMENTI MISURE MTM"
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  class: {
                                                    "active-expansion":
                                                      _vm.showVariazioniArrayItemsMisureMtm,
                                                  },
                                                  staticStyle: {
                                                    "margin-left": "10px",
                                                  },
                                                },
                                                [_vm._v(" mdi-chevron-down")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              (_vm.ordine.variazioniArrayItemsMisureMtm || [])
                                .length > 0 &&
                              _vm.showVariazioniArrayItemsMisureMtm
                                ? _c(
                                    "v-list",
                                    { staticClass: "mb-4" },
                                    [
                                      _vm._l(
                                        _vm.ordine
                                          .variazioniArrayItemsMisureMtm,
                                        function (variazione, i) {
                                          return [
                                            _c(
                                              "ItemListVariazioneArrayItemsOrdineMTM",
                                              {
                                                key: variazione.id,
                                                attrs: {
                                                  displayProperty:
                                                    "nome misura",
                                                  variazione: variazione,
                                                },
                                                on: {
                                                  "conferma-variazione": (e) =>
                                                    _vm.confermaVariazioneArrayItems(
                                                      e,
                                                      "MisureMTM"
                                                    ),
                                                },
                                              }
                                            ),
                                            i <
                                            _vm.ordine
                                              .variazioniArrayItemsMisureMtm
                                              .length -
                                              1
                                              ? _c("v-divider")
                                              : _vm._e(),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-tabs",
                                    [
                                      _vm._l(
                                        _vm.misurePerTipo,
                                        function (g, i) {
                                          return _c(
                                            "v-tab",
                                            { key: i },
                                            [
                                              _vm._v(" " + _vm._s(g[0]) + " "),
                                              g[1].hasVariazioni
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { right: "" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-alert-octagon-outline"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._l(
                                        _vm.misurePerTipo,
                                        function (g, i) {
                                          return _c(
                                            "v-tab-item",
                                            { key: i },
                                            [
                                              _c(
                                                "v-list",
                                                { style: { padding: "0" } },
                                                [
                                                  _vm._l(
                                                    g[1].items,
                                                    function (m, k) {
                                                      return [
                                                        _c(
                                                          "ItemListMisuraMTM",
                                                          {
                                                            key: k,
                                                            attrs: {
                                                              misura: m,
                                                            },
                                                            on: {
                                                              "conferma-variazione":
                                                                (e) =>
                                                                  _vm.confermaVariazioneSubArray(
                                                                    e,
                                                                    "MisureMTM"
                                                                  ),
                                                            },
                                                          }
                                                        ),
                                                        k <
                                                        g[1].items.length - 1
                                                          ? _c("v-divider")
                                                          : _vm._e(),
                                                      ]
                                                    }
                                                  ),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.displayAllegati
                            ? _c(
                                "v-flex",
                                { attrs: { xs10: "", "offset-xs1": "" } },
                                [
                                  _c("v-card-title", [
                                    _c("h2", [_vm._v("ALLEGATI")]),
                                  ]),
                                  (
                                    _vm.ordine
                                      .variazioniArrayItemsAllegatiOrdine || []
                                  ).length > 0
                                    ? _c(
                                        "v-card",
                                        {
                                          class: {
                                            "mb-4":
                                              !_vm.showVariazioniArrayItemsAllegatiOrdine,
                                          },
                                          attrs: { hover: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showVariazioniArrayItemsAllegatiOrdine =
                                                !_vm.showVariazioniArrayItemsAllegatiOrdine
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" },
                                                },
                                                [
                                                  _c(
                                                    "h2",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "VARIAZIONI ELEMENTI ALLEGATI ORDINE"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      class: {
                                                        "active-expansion":
                                                          _vm.showVariazioniArrayItemsAllegatiOrdine,
                                                      },
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " mdi-chevron-down"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (
                                    _vm.ordine
                                      .variazioniArrayItemsAllegatiOrdine || []
                                  ).length > 0 &&
                                  _vm.showVariazioniArrayItemsAllegatiOrdine
                                    ? _c(
                                        "v-list",
                                        { staticClass: "mb-4" },
                                        [
                                          _vm._l(
                                            _vm.ordine
                                              .variazioniArrayItemsAllegatiOrdine,
                                            function (variazione, i) {
                                              return [
                                                _c(
                                                  "ItemListVariazioneArrayItemsOrdineMTM",
                                                  {
                                                    key: variazione.id,
                                                    attrs: {
                                                      displayProperty:
                                                        "nome file",
                                                      variazione: variazione,
                                                    },
                                                    on: {
                                                      "conferma-variazione": (
                                                        e
                                                      ) =>
                                                        _vm.confermaVariazioneArrayItems(
                                                          e,
                                                          "AllegatiOrdine"
                                                        ),
                                                    },
                                                  }
                                                ),
                                                i <
                                                _vm.ordine
                                                  .variazioniArrayItemsAllegatiOrdine
                                                  .length -
                                                  1
                                                  ? _c("v-divider")
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  (
                                    _vm.ordine
                                      .variazioniArrayItemsAllegatiCliente || []
                                  ).length > 0
                                    ? _c(
                                        "v-card",
                                        {
                                          class: {
                                            "mb-4":
                                              !_vm.showVariazioniArrayItemsAllegatiCliente,
                                          },
                                          attrs: { hover: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.showVariazioniArrayItemsAllegatiCliente =
                                                !_vm.showVariazioniArrayItemsAllegatiCliente
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" },
                                                },
                                                [
                                                  _c(
                                                    "h2",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          "VARIAZIONI ELEMENTI ALLEGATI CLIENTE"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      class: {
                                                        "active-expansion":
                                                          _vm.showVariazioniArrayItemsAllegatiCliente,
                                                      },
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " mdi-chevron-down"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  (
                                    _vm.ordine
                                      .variazioniArrayItemsAllegatiCliente || []
                                  ).length > 0 &&
                                  _vm.showVariazioniArrayItemsAllegatiCliente
                                    ? _c(
                                        "v-list",
                                        { staticClass: "mb-4" },
                                        [
                                          _vm._l(
                                            _vm.ordine
                                              .variazioniArrayItemsAllegatiCliente,
                                            function (variazione, i) {
                                              return [
                                                _c(
                                                  "ItemListVariazioneArrayItemsOrdineMTM",
                                                  {
                                                    key: variazione.id,
                                                    attrs: {
                                                      displayProperty:
                                                        "nome file",
                                                      variazione: variazione,
                                                    },
                                                    on: {
                                                      "conferma-variazione": (
                                                        e
                                                      ) =>
                                                        _vm.confermaVariazioneArrayItems(
                                                          e,
                                                          "AllegatiCliente"
                                                        ),
                                                    },
                                                  }
                                                ),
                                                i <
                                                _vm.ordine
                                                  .variazioniArrayItemsAllegatiCliente
                                                  .length -
                                                  1
                                                  ? _c("v-divider")
                                                  : _vm._e(),
                                              ]
                                            }
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-tabs",
                                        [
                                          _vm.displayAllegatiOrdine
                                            ? _c("v-tab", { key: 0 }, [
                                                _vm._v(" ORDINE "),
                                              ])
                                            : _vm._e(),
                                          _vm.displayAllegatiOrdine
                                            ? _c(
                                                "v-tab-item",
                                                { key: 0 },
                                                [
                                                  _c(
                                                    "v-list",
                                                    { style: { padding: "0" } },
                                                    [
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticStyle: {
                                                              "padding-bottom":
                                                                "24px",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.ordine
                                                              .allegatiOrdine,
                                                            function (
                                                              allegatoOrdine
                                                            ) {
                                                              return _c(
                                                                "v-btn",
                                                                {
                                                                  key: allegatoOrdine.idAllegato,
                                                                  staticStyle: {
                                                                    color:
                                                                      "white",
                                                                    "margin-top":
                                                                      "10px",
                                                                    "margin-left":
                                                                      "10px",
                                                                  },
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.buttonDownloadIsLoading(
                                                                        allegatoOrdine.idAllegato
                                                                      ),
                                                                    color:
                                                                      "green lighten-2",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.downloadAllegato(
                                                                          allegatoOrdine.idAllegato,
                                                                          allegatoOrdine.nomeFile,
                                                                          _vm
                                                                            .ordine
                                                                            .fornitore
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        allegatoOrdine.nomeFile
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-download"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.displayAllegatiCliente
                                            ? _c("v-tab", { key: 1 }, [
                                                _vm._v(" CLIENTE "),
                                              ])
                                            : _vm._e(),
                                          _vm.displayAllegatiCliente
                                            ? _c(
                                                "v-tab-item",
                                                { key: 1 },
                                                [
                                                  _c(
                                                    "v-list",
                                                    { style: { padding: "0" } },
                                                    [
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticStyle: {
                                                              "padding-bottom":
                                                                "24px",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.ordine
                                                              .allegatiCliente,
                                                            function (
                                                              allegatoCliente
                                                            ) {
                                                              return _c(
                                                                "v-btn",
                                                                {
                                                                  key: allegatoCliente.idAllegato,
                                                                  staticStyle: {
                                                                    color:
                                                                      "white",
                                                                    "margin-top":
                                                                      "10px",
                                                                    "margin-left":
                                                                      "10px",
                                                                  },
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.buttonDownloadIsLoading(
                                                                        allegatoCliente.idAllegato
                                                                      ),
                                                                    color:
                                                                      "green lighten-2",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.downloadAllegato(
                                                                          allegatoCliente.idAllegato,
                                                                          allegatoCliente.nomeFile,
                                                                          _vm
                                                                            .ordine
                                                                            .fornitore
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        allegatoCliente.nomeFile
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        right:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-download"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v(" OPPPSSS... Nessun dato da visualizzare. "),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }